<div class="build-details-container">
  <nz-spin [nzSpinning]="loading">

    <div *ngIf="error" class="error-message">
      <nz-alert nzType="error" [nzMessage]="error" nzShowIcon></nz-alert>
    </div>

    <ng-container *ngIf="!loading && !error">
      <div class="mb-md mt-lg row-page">
        <div>
          <span class="fw-bold">Build Details ({{totalElements}})</span>
        </div>
        <div *ngIf="totalElements > 0">
          <span class="mr-sm">Rows per page:</span>
          <nz-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)" class="w80">
            <nz-option [nzValue]="10" nzLabel="10"></nz-option>
            <nz-option [nzValue]="20" nzLabel="20"></nz-option>
            <nz-option [nzValue]="50" nzLabel="50"></nz-option>
            <nz-option [nzValue]="100" nzLabel="100"></nz-option>
          </nz-select>
        </div>
      </div>

      <nz-table class="declaration-table" #buildTable [nzData]="paginatedData" [nzTotal]="totalElements" 
        [nzFrontPagination]="true" [nzShowPagination]="false" [nzPageSize]="pageSize" 
        [nzScroll]="{ x: '600px' }">
        <thead (nzSortOrderChange)="sort($event)" nzSingleSort>
          <tr>
            <th nzShowSort nzColumnKey="service" [nzSortFn]="true">Service</th>
            <th nzShowSort nzColumnKey="buildNumber" [nzSortFn]="true">Build Number</th>
            <th nzShowSort nzColumnKey="branchName" [nzSortFn]="true">Branch</th>
            <th nzShowSort nzColumnKey="deployedBy" [nzSortFn]="true">Deployed By</th>
            <th nzShowSort nzColumnKey="status" [nzSortFn]="true">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of buildTable.data">
            <td>{{ item.service }}</td>
            <td>{{ item.buildNumber }}</td>
            <td>{{ item.branchName }}</td>
            <td>{{ item.deployedBy }}</td>
            <td>
              <span [style.color]="item.status === 'succeeded' ? 'green' : item.status === 'inProgress' ? 'blue' : item.status === 'canceled' ? 'orange' : 'red'">
                <strong>{{ item.status | uppercase }}</strong>
              </span>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </ng-container>

  </nz-spin>

  <div class="pagination-footer" *ngIf="!loading && !error && totalElements > 0">
    <div class="pagination-container">
      <div>
        <nz-pagination [(nzPageIndex)]="currentPage" [nzTotal]="totalElements" [nzPageSize]="pageSize" 
          (nzPageIndexChange)="changePagination($event)"></nz-pagination>
      </div>
      <div>
        <span class="mr-sm">Go to:</span>
        <input nz-input [(ngModel)]="gotoPageNumber" placeholder="Page" type="number" [min]="1" [max]="maxPages" class="mr-sm w80 inline-block" (keyup.enter)="goToPage()" />
        <button nz-button nzType="primary" (click)="goToPage()" [disabled]="!gotoPageNumber">Go</button>
      </div>
    </div>
  </div>
</div>
